import { Components, Theme } from '@mui/material/styles';

import * as Colors from 'src/theme/colors';

const MuiTooltip: Components<Theme>['MuiTooltip'] = {
  styleOverrides: {
    tooltip: {
      backgroundColor: Colors.BlackHeadings,
      boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
      fontSize: '0.75rem', // 12px on default screen size
    },
  },
};

export default MuiTooltip;
